import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestInvoices = ({ qs }: {
  qs?: any
} = {}): Action => ({
  type: actionTypes.REQUEST_INVOICES,
  qs,
});

export const requestUserTransactions = () => ({
  type: actionTypes.REQUEST_USER_TRANSACTIONS,
});

export const requestSubscriptionPlans = () => ({
  type: actionTypes.REQUEST_SUBSCRIPTION_PLANS,
});

export const requestCurrentCustomer = () => ({
  type: actionTypes.REQUEST_CURRENT_CUSTOMER,
});

export const requestPaymentAttempt = (callbacks: SagaCallbacks) => ({
  type: actionTypes.REQUEST_PAYMENT_ATTEMPT,
  callbacks,
});

export const requestSetPlan = ({ body, callbacks }: {
  body: any
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_SET_SUBSCRIPTION,
  body,
  callbacks,
});

export const requestUpdateSubscription = ({
  id,
  body,
  callbacks,
}: {
  id: number
  body: any
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_SUBSCRIPTION,
  id,
  body,
  callbacks,
});

export const requestPaymentIntentsSetup = () => ({
  type: actionTypes.REQUEST_PAYMENT_INTENTS_SETUP,
});

export const requestGetPaymentMethods = ({ callbacks }: {
  callbacks?: SagaCallbacks
} = {}): Action => ({
  type: actionTypes.REQUEST_GET_PAYMENT_METHODS,
  callbacks,
});

export const requestCreatePaymentMethod = ({
  qs,
  body,
  callbacks,
}: {
  qs: any
  body: any
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_CREATE_PAYMENT_METHOD,
  qs,
  body,
  callbacks,
});

export const requestDeletePaymentMethod = ({ id, callbacks }: {
  id: number
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_DELETE_PAYMENT_METHOD,
  id,
  callbacks,
});

export const requestSetDefaultPaymentMethod = ({ id, callbacks }: {
  id: number
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_SET_DEFAULT_PAYMENT_METHOD,
  id,
  callbacks,
});

export const requestCancelSubscription = ({ id, callbacks }: {
  id: number
  callbacks?: SagaCallbacks
}) => ({
  type: actionTypes.CANCEL_SUBSCRIPTION_REQUEST,
  id,
  callbacks,
});

export const setSubscription = (subscription: any) => ({
  type: actionTypes.SET_SUBSCRIPTION,
  payload: {
    subscription,
  },
});

export const setPaymentState = (payload: any) => ({
  type: actionTypes.SET_PAYMENT_STATE,
  payload,
});

export const requestCreateInvoice = ({ payload, callbacks }: {
  payload: any,
  callbacks?: SagaCallbacks,
}) => ({
  type: actionTypes.REQUEST_CREATE_INVOICE,
  payload,
  callbacks,
});
